type BaseNamePath = string | number | boolean | (string | number | boolean)[];

type DeepNamePath<
    Store = any,
    ParentNamePath extends any[] = [],
> = ParentNamePath['length'] extends 10
    ? never
    : true extends (Store extends BaseNamePath ? true : false)
    ? ParentNamePath['length'] extends 0
        ? Store | BaseNamePath
        : Store extends any[]
        ? [...ParentNamePath, number]
        : never
    : Store extends any[] // Connect path. e.g. { a: { b: string }[] }
    ?
          | [...ParentNamePath, number]
          | DeepNamePath<Store[number], [...ParentNamePath, number]>
    : keyof Store extends never
    ? Store
    : {
          // eslint-disable-next-line @typescript-eslint/ban-types
          [FieldKey in keyof Store]: Store[FieldKey] extends Function
              ? never
              :
                    | (ParentNamePath['length'] extends 0 ? FieldKey : never)
                    | [...ParentNamePath, FieldKey]
                    | DeepNamePath<
                          Required<Store>[FieldKey],
                          [...ParentNamePath, FieldKey]
                      >;
      }[keyof Store];

export type NamePath<T = any> = DeepNamePath<T>;

export type ListFilter<T> = Omit<T, 'page' | 'size' | 'sort'>;

function namePathToArray(path?: NamePath): any[] {
    if (path === undefined || path === null) {
        return [];
    }

    return Array.isArray(path) ? path : [path];
}

function createNameProvider<T>() {
    return {
        /**
         * Used to specify the correct path to a property based on the passed data type.
         * Returns the path to the property as an array
         * @param values
         * @returns Returns the path to the property as an array
         */
        getPath: (values: NamePath<T>) => {
            const path = namePathToArray(values);

            return path as NamePath<T>;
        },
    };
}

export const FormHelper = {
    createNameProvider,
};
